import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const notifications = [['SM', 'Sarah M.', 'London, United Kingdom', '5 minutes ago'], ['CV', 'Clara V.', 'Toronto, Canada', '12 minutes ago'], ['JR', 'James R.', 'Sydney, Australia', '18 minutes ago']];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 3500);
    const rotate = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(current => (current + 1) % notifications.length);
        setVisible(true);
      }, 500);
    }, 7000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(rotate);
    };
  }, [dismissed]);
  const [initials, name, city, time] = notifications[index];
  return <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 w-full max-w-sm -translate-x-1/2 px-4" data-id="element-215">
      <AnimatePresence data-id="element-216">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 12
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-[#d9c68d] bg-white p-3.5 shadow-card" data-id="element-217">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-navy-900 text-xs font-extrabold text-gold-300" data-id="element-218">
              {initials}
            </span>
            <div className="min-w-0" data-id="element-219">
              <p className="text-xs font-semibold text-navy-700" data-id="element-220">{city}</p>
              <p className="text-sm text-navy-950" data-id="element-221">
                <strong data-id="element-222">{name}</strong> got ESL Teacher Ready™
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-emerald-600" data-id="element-223">
                <ShoppingBagIcon size={11} data-id="element-224" /> Verified purchase · {time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 text-slate-400 transition hover:text-navy-950" data-id="element-225">
              <XIcon size={14} data-id="element-226" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}